import { isInViewport } from '~js/utils/utils';

export const isCompletelyOutOfViewport = (element) => {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  return rect.bottom <= 0;
};

export const initializeStickyButton = () => {
  const buybox = document.querySelector('.js-pdp-atc-btn');
  if (!buybox) return;
  const stickyButton = document.querySelector('.sticky-button');
  const promotionalBanner = document.querySelector(
    '.promotional-banner-sticky',
  );
  if (!stickyButton && !promotionalBanner) return;
  let lastScrollY = window.scrollY;
  const screenBreakPoint = 1024;

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const isWideScreen = window.innerWidth >= screenBreakPoint;
    const buyboxCompletelyOut = isCompletelyOutOfViewport(buybox);

    const showStickyButtonDesktop = isWideScreen && buyboxCompletelyOut;
    const showBannerDesktop = isWideScreen && buyboxCompletelyOut;
    const showStickyButtonMobile =
      !isWideScreen && buyboxCompletelyOut && currentScrollY !== 0;
    const showBannerMobile =
      !isWideScreen && buyboxCompletelyOut && currentScrollY !== 0;

    stickyButton.classList.toggle(
      'is-hidden',
      !(showStickyButtonDesktop || showStickyButtonMobile),
    );
    promotionalBanner.classList.toggle(
      'is-hidden',
      !(showBannerDesktop || showBannerMobile),
    );

    lastScrollY = currentScrollY;
  }

  function handleResize() {
    const isWideScreen = window.innerWidth >= screenBreakPoint;
    const buyboxInViewport = isInViewport(buybox);

    const showStickyButton = isWideScreen && !buyboxInViewport;
    const showBanner = isWideScreen && !buyboxInViewport;
    stickyButton.classList.toggle('is-hidden', !showStickyButton);
    showBanner.classList.toggle('is-hidden', !showBanner);
  }

  function handlePageLoad() {
    const isWideScreen = window.innerWidth >= screenBreakPoint;
    const buyboxInViewport = isInViewport(buybox);
    const showStickyButton =
      !buyboxInViewport &&
      (isWideScreen || (!isWideScreen && window.scrollY !== 0));
    const showBanner =
      !buyboxInViewport &&
      (isWideScreen || (!isWideScreen && window.scrollY !== 0));
    stickyButton.classList.toggle('is-hidden', !showStickyButton);
    showBanner.classList.toggle('is-hidden', !showBanner);
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleResize);

  handlePageLoad();
};
